import React from "react";
import style from "./style.module.css";
import MultiLanguageTranslate from "../../../../_components/Translate/MultiLangTranslate";
import { isMobile } from "../helperFunc";
const FilterTab = ({ selectedFilter, setSelectedFilter, data }) => {
  return (
    <>
      <div
        className={`d-flex ${
          isMobile ? "margin16" : "margin-top16 margin-bottom16"
        }`}
      >
        {data.map((item) => {
          return (
            <div
              className={`cursorPointer ${
                isMobile
                  ? "line-height14 letterSpacing025 font-size12"
                  : "letterSpacing05"
              } padding-top8 padding-bottom8 margin-right16 ${
                item == selectedFilter
                  ? `${style["selectedColor"]} font-weight500 boxRadius8 padding-left16 padding-right16`
                  : `colorDark9 font-weight400 ${
                      isMobile ? "" : "padding-left12"
                    }`
              }`}
              onClick={() => setSelectedFilter(item)}
            >
              {typeof item === "string" ? (
                <MultiLanguageTranslate title={`${item}`} />
              ) : (
                item
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};
export default FilterTab;
